module.exports = __webpack_public_path__ + "static/media/web-ats-05.313eee12.jpg";